import React, { useContext, useState, useEffect } from "react";

/** Context */
import { StepContext } from "../../context/StepContext";

/** React string HTML parser */
import parse from "html-react-parser";

/** Styles */
import "../../sass/blocks/_start.scss";

const ContestStartView = (props) => {
    const { step, setStep } = useContext(StepContext);

    let data = JSON.parse(props.description);

    const [areTermsAccepted, setAreTermsAccepted] = useState(false);
    const [showTermsValidationError, setShowTermsValidationError] =
        useState(false);

    const nextStepHandler = () => {
        if (!areTermsAccepted && data.terms_acceptation_required) {
            setShowTermsValidationError(true);
            return;
        }

        setStep(step + 1);
    };

    useEffect(() => {
        setShowTermsValidationError(false);
    }, [areTermsAccepted]);

    return (
        <>
            <section className="start">
                <h2 className="start__title"> {data.title} </h2>
                <h2 className="start__subtitle"> {data.subtitle} </h2>
                <h2 className="start__desc"> {parse(data.desc)} </h2>
                <div className="start-logo">
                    <img
                        className="start-logo__img"
                        src={data.logo}
                        alt=""
                    ></img>
                    <div className="start-rules">
                        <p className="start-rules__paragraph">Do dzieła!</p>
                        <a
                            className="start-rules__link"
                            href={data.link.url}
                            target="_blank"
                        >
                            {data.link.title}
                        </a>
                    </div>
                </div>

                {data.terms_acceptation_required && (
                    <div className="start-acceptation">
                        <div className="start-acceptation__checkbox-wrapper">
                            <input
                                type="checkbox"
                                id="rules-acceptance"
                                checked={areTermsAccepted}
                                onChange={() =>
                                    setAreTermsAccepted(
                                        (prevState) => !prevState
                                    )
                                }
                                className="start-acceptation__checkbox"
                            />
                            <label
                                className={`start-acceptation__label ${
                                    showTermsValidationError ? "-error" : ""
                                }`}
                                htmlFor="rules-acceptance"
                            >
                                {data.terms_acceptation_checkbox_label}
                            </label>
                        </div>

                        {showTermsValidationError && (
                            <p className="start-acceptation__error-msg">
                                Zaznacz wszystkie zgody aby przejść dalej!
                            </p>
                        )}
                    </div>
                )}

                <div className="start-button">
                    <button
                        onClick={nextStepHandler}
                        className="start-button__button"
                        style={{ backgroundColor: data.bg_color_start_button }}
                    >
                        start
                    </button>
                </div>
            </section>
        </>
    );
};

export default ContestStartView;
